<script setup>
import { computed } from 'vue';
import {VIEWBOX_SIZE, industryAverageTooltip} from "@/components/seo-score/visibility-chart/composables/radialChart";
import {POST_ANIMATION_FADE_IN_DURATION_MS, postAnimationEffectsCompleted} from "@/components/seo-score/visibility-chart/composables/animation";

const props = defineProps({
  industryAverage: {
    type: [Number, null],
    required: false,
    default: null,
  },
  startPostAnimationEffects: {
    type: Boolean,
    default: false,
  },
});

const fontSize = (VIEWBOX_SIZE * 0.018).toFixed(4);
const x = (VIEWBOX_SIZE * 0.02).toFixed(4);

const animationCompleted = postAnimationEffectsCompleted(() => props.startPostAnimationEffects);
const legendTooltip = computed(() => industryAverageTooltip(props.industryAverage, animationCompleted.value));
</script>

<template>
  <g>
    <g
      v-if="industryAverage > 0"
      v-tooltip="legendTooltip"
      :transform="`translate(${(VIEWBOX_SIZE * 0.85).toFixed(4)}, ${(VIEWBOX_SIZE * 0.02).toFixed(4)})`"
      :class="{ 'tw-cursor-pointer': legendTooltip }"
      :style="{
        opacity: startPostAnimationEffects ? 1 : 0,
        transition: `opacity ${POST_ANIMATION_FADE_IN_DURATION_MS}ms ease`,
      }"
    >
      <circle
        :r="(VIEWBOX_SIZE * 0.007).toFixed(4)"
        class="tw-fill-neutral-900"
      />
      <text
        :x="x"
        text-anchor="start"
        dominant-baseline="middle"
        :font-size="fontSize"
        class="tw-fill-neutral-900"
      >
        Industry Average
      </text>
    </g>
  </g>
</template>
